var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-date-picker",
        _vm._g(
          {
            staticStyle: { height: "100%" },
            attrs: {
              type: _vm.type,
              clearable: "",
              "value-format": _vm.format,
              "picker-options": _vm.options,
              "range-separator": _vm.$t("placeHolder.to"),
              "start-placeholder":
                _vm.placeholderspan + _vm.$t("placeHolder.start"),
              "end-placeholder":
                _vm.placeholderspan + _vm.$t("placeHolder.end"),
              size: "mini"
            },
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          },
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }